import styled from '@emotion/styled';

export const FlagImg = styled.img`
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  object-fit: contain;
  display: block;
`;
